module.exports = __webpack_public_path__ + "static/media/No_Records.0379bab9.svg";